import React from 'react';
import CouponUsersTrackContainer from '../../../Containers/AdminContainer/CouponUsersTrack';

const CouponUsersTrackScreen = () => {
  return <CouponUsersTrackContainer />;
};

export default CouponUsersTrackScreen;
